$(document).ready(function () {
    $(document).on('click', '.popup_close, .complain_close', function () {
        $(".popup-content").show();
        $(".popup-complete").css("display", "none");
    });

    function ajaxUpdate() {
        $.get("/bitrix/templates/timecity/ajax/basketupdate.php", function (data) {
            $('.dds_basket_insert').html(data);
            BX.onCustomEvent('OnBasketChange');

            BX.ready(function () {
                BX.ajax.insertToNode(BX.message('SITE_DIR') + 'ajax/upd_cart.php', 'topCartCnt')
            })
        });
    }


    $(document).on('click change submit', "[data-action='delete'],[data-action='updatebasket']", function (e) {
        let action = $(this).attr('data-action')
        let $this = $(this)
        let data = {}
        data['action'] = action

        switch (e.type) {
            case 'click':
                switch (action) {
                    case 'delete':
                        data['id'] = $this.attr('data-id')
                        break
                    default:
                        return false
                }
                break
            case 'change':
                switch (action) {
                    case 'updatebasket':
                        data['id'] = $this.attr('data-id')
                        data['quantity'] = $this.val()
                        break
                    default:
                        return false
                }
                break;

            case 'submit':
            default:
                return false
        }

        $.ajax({
            url: "/bitrix/templates/timecity/ajax/ajax.php",
            type: "POST",
            dataType: 'json',
            data: data,
            success: function () {
                ajaxUpdate()
            }
        })
        return false
    })

    $(document).on('click', '.order_open', function () {
        $('[name=ITEM]').val($(this).attr('data-id'));
    })

    // Функция активации вкладок доставки в заказе
    function deliveryTab(tab) {
        let allDataTab = $('[data-tab-id]')
        // Скрываем все вкладки
        allDataTab.hide()
        // Все поля деактивируем
        allDataTab.find('input, select, textarea').prop('disabled', true)
        // Получаем data-tab id открытой вкладки
        let id = tab.attr('data-tab')
        let activeDataTab = $('[data-tab-id=' + id + ']')
        // Показываем активную вкладку
        activeDataTab.show()
        // Убираем disabled со всех полей у которых нет класса disabled
        activeDataTab.find('input:not(.disabled), select:not(.disabled), textarea:not(.disabled)').prop('disabled', false)

        //Платёжные системы в зависимости от доставки
        $(".payment-method li").hide()
        $("." + id).show()
        $(".payment-method li input").prop("checked", false)

        let checkedPaymentInput = $("." + id + " input[checked]");

        if (checkedPaymentInput) {
            checkedPaymentInput.prop("checked", true);
        } else {
            $("." + id + ":first input").prop("checked", true);
        }
    }

    let tab = $('[name="delivery"][checked]')
    deliveryTab(tab)
    $(document).on('change', '[name="delivery"]', function () {
        deliveryTab($(this))
    })


    $(document).on('change')
    $(document).on('keyup', '.search_input', function () {
        $(this).closest(".search").addClass("loading");
        $.get(BX.message('SITE_DIR') + 'ajax/search.php?q=' + $(this).val(), function (data) {
            $('ul.search-live-list *').remove()
            $('ul.search-live-list').append(data)
            $('ul.search-live-list').closest(".search").removeClass('loading')
        })
    })
})